import store from 'app/store';

export default function dismissModal(id) {
  if (typeof id === 'string') {
    store.get().dispatch({
      type: 'MODAL_DISMISS',
      id,
    });
  } else if (Object(id) === id) {
    store.get().dispatch({
      type: 'MODAL_DISMISS',
      scope: id,
    });
  }
}
